import { FileUpload } from '../../../models/file-upload';
import Modal from '../modal/modal.component';
import { FileUploadReEditModalComponent } from './file-upload-reedit-modal.component';
import { ReeditSuggestion } from './reedit-footer-mode';

/**
 * THE way into the Re-edit modal (prod fixes 2026-10-02, PLAN.md C6). The card's Re-edit button
 * (`file-list-item.component.tsx`), the tool page's Re-run row (`recent-on-page.component.tsx`) and FIX-3's
 * "Make it smaller" all call it, so FIX-2's availability check (T3) is added in ONE place, between the
 * entry point's own routing and the modal.
 *
 * Each entry point keeps its own behaviour, passed in, so this refactor changes nothing:
 *  - [ReeditFlowOptions.route]: the entry point's routing that may take the click elsewhere (the card: the
 *    Studio, the picker, the expired state; the Re-run row: the Studio). `true` = handled, no modal.
 *  - [ReeditFlowOptions.prepare]: loads the upload/websocket stack the modal needs, under the entry point's
 *    own spinner.
 * The modal opens with exactly `{ fileUpload }`, plus `suggestion` / `onDownloadExisting` only when given.
 */
export interface ReeditFlowOptions {
    route?: (card: FileUpload) => boolean | Promise<boolean>;
    prepare?: () => Promise<void>;
    suggestion?: ReeditSuggestion;
    onDownloadExisting?: () => void;
}

export type ReeditFlowOutcome = 'routed' | 'opened';

export async function openReeditFlow(card: FileUpload, opts: ReeditFlowOptions = {}): Promise<ReeditFlowOutcome> {
    if (opts.route && await opts.route(card)) return 'routed';
    if (opts.prepare) await opts.prepare();
    const initialState: { fileUpload: FileUpload; suggestion?: ReeditSuggestion; onDownloadExisting?: () => void } = { fileUpload: card };
    if (opts.suggestion) initialState.suggestion = opts.suggestion;
    if (opts.onDownloadExisting) initialState.onDownloadExisting = opts.onDownloadExisting;
    Modal.createModal(FileUploadReEditModalComponent, initialState);
    return 'opened';
}
